import { Helmet } from "react-helmet-async";
import { SITE, SEO_DEFAULTS } from "../content";

export function Seo({ title, description = SEO_DEFAULTS.description, path = "/", noindex = false }) {
  const fullTitle =
    path === "/"
      ? `${SITE.name} — Your Instagram DMs, Wrapped (Private & On-Device)`
      : `${title} | ${SITE.name}`;
  const canonical = `${SITE.url}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={SEO_DEFAULTS.keywords} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      <meta name="theme-color" content="#D1F942" />
      <link rel="icon" type="image/png" href="/favicon.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon.png" />
      <link rel="icon" type="image/png" sizes="192x192" href="/logo-192.png" />
      <link rel="apple-touch-icon" href="/logo-192.png" />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={SITE.ogImage} />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={SITE.ogImage} />
    </Helmet>
  );
}
